export function getBanners ({ state, commit }, page = 1) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/banners', { params: { page: page } })
      .then((response) => {
        if (response.data.banners) {
          commit('setBanners', response.data.banners)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getBanner ({ state, commit }, bannerId) {
  return new Promise((resolve, reject) => {
    if (bannerId) {
      axiosInstance.get('/v1/banners/' + bannerId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banner id'))
    }
  })
}

export function getCreateBanner ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/banners/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createBanner ({ state, commit }, { description, slide, slide_position, parent_slider, link, event, start, end, warehouse }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/banners', { description, slide, slide_position, parent_slider, link, event, start, end, warehouse })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditBanner ({ state, commit }, bannerId) {
  return new Promise((resolve, reject) => {
    if (bannerId) {
      axiosInstance.get('/v1/banners/' + bannerId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banner id'))
    }
  })
}

/* eslint-disable-next-line */
export function editBanner ({ state, commit }, { id, description, slide, slide_position, parent_slider, link, event, start, end, warehouse }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/banners/' + id, { description, slide, slide_position, parent_slider, link, event, start, end, warehouse })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banner id'))
    }
  })
}

export function deleteBanner ({ state, commit }, bannerId) {
  return new Promise((resolve, reject) => {
    if (bannerId) {
      axiosInstance.delete('/v1/banners/' + bannerId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banner id'))
    }
  })
}

export function upload ({ state, commit }, formData) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/banners/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
